import { Controller } from "@hotwired/stimulus"

// This controller is used to trigger an event when a filter is added, the event is used with stimulus actions to
// trigger other stimulus controllers.
export default class extends Controller {
  static get values() {
    return {
      context: { type: String, default: "" } // Add context value with empty default for backward compatibility
    }
  }

  add(event) {
    // Create event detail object
    const detail = { name: event.params.name }

    // Only add context if it's set (backward compatibility)
    if (this.contextValue) {
      detail.context = this.contextValue
    }

    // Dispatch the add event with the detail
    this.dispatch("add", { detail })
  }
}
